export class DateOnly {
	date: Date;
	constructor(value: Date);
	constructor(year: number, month: number, day: number);
	constructor(yearOrData: Date | number, month?: number, day?: number) {
		if (yearOrData instanceof Date) {
			this.date = yearOrData;
			return;
		}
		if (typeof (yearOrData) === "number" && month !== undefined && day !== undefined) {
			this.date = new Date(yearOrData, month - 1, day);
			return;
		}
		throw new Error('Invalid Arguments in DateTime constructor');
	}
	static get today() {
		return new DateOnly(new Date());
	}
	get javaScriptDate() {
		return new Date(this.date);
	}
	get day() {
		return this.date.getDate();
	}
	get dayOfWeek() {
		return this.date.getDay();
	}
	get month() {
		return this.date.getMonth() + 1;
	}
	get year() {
		return this.date.getFullYear();
	}
	get endOfMonth() {
		return new DateOnly(this.year, this.month + 1, 0);
	}
	addDays(value: number) {
		const d = new Date(this.date);
		const diff = d.getDate() + value;
		return new DateOnly(new Date(d.setDate(diff)));
	}
	addMonths(numOfMonths: number) {
		const date = new Date(this.date);
		const year = date.getFullYear();
		const month = date.getMonth();
		const day = date.getDate();
		if (day <= 27) return new DateOnly(this.year, this.month + numOfMonths, this.day);
		const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
		if (day === lastDay) return new DateOnly(this.year, this.month + 1 + numOfMonths, 0);
		let newDate2 = new Date(year, month + numOfMonths, day);
		const monthDiff = (newDate2.getMonth() + 12 - date.getMonth()) % 12;
		if (monthDiff > numOfMonths) {
			newDate2 = new Date(newDate2.getFullYear(), newDate2.getMonth(), 0)
		}
		return new DateOnly(newDate2);
	}
	isEndOfMonth() {
		return this.day === this.endOfMonth.day;
	}
	isGreaterThen(value: DateOnly) {
		const self = new Date(this.year, this.month, this.day);
		const d2 = new Date(value.year, value.month, value.day);
		return self > d2;
	}
	isLessThenEqualTo(value: DateOnly) {
		const self = new Date(this.year, this.month, this.day);
		const d2 = new Date(value.year, value.month, value.day);
		return self <= d2;
	}
	differenceInDays(value: DateOnly) {
		const msPerDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
		const diffInMs = this.javaScriptDate.getTime() - value.javaScriptDate.getTime(); // Difference in milliseconds
		return Math.round(diffInMs / msPerDay); // Convert to days
	}
	format(): string {
		return new Intl.DateTimeFormat(undefined, {
			year: "numeric",
			month: "long",
			day: "numeric"
		}).format(this.date);
	}
	apiFormat(): string {
		return new Intl.DateTimeFormat("en-CA").format(this.date);
	}
	static parse(date: string) {
		const [year, month, day] = date.split("-").map(p => parseInt(p));
		return new DateOnly(year, month, day);
	}
	toString() {
		return this.date.toString();
	}
}
